import { useState, useEffect } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../firebaseConfig';

export const useAccountingReport = (condominoId, startDate, endDate, excludeClosing = false) => {
    const [loading, setLoading] = useState(true);
    const [accounts, setAccounts] = useState([]);
    const [ledgerEntries, setLedgerEntries] = useState([]);
    const [balances, setBalances] = useState({});

    useEffect(() => {
        if (!condominoId) return;

        const fetchData = async () => {
            setLoading(true);
            try {
                // 1. Fetch Chart of Accounts
                const qAccounts = query(collection(db, "cuentas_contables"), where("condominioId", "==", condominoId));
                const snapAccounts = await getDocs(qAccounts);
                const accountMap = {};
                snapAccounts.docs.forEach(doc => {
                    accountMap[doc.id] = { id: doc.id, ...doc.data() };
                });
                setAccounts(Object.values(accountMap));

                // 2. Fetch Ledger Entries (Asientos)
                let qLedger = query(collection(db, "contabilidad_asientos"), where("condominioId", "==", condominoId));
                const snapLedger = await getDocs(qLedger);
                const entries = snapLedger.docs.map(doc => ({ id: doc.id, ...doc.data() }));

                // Filter in memory for precise dates and optionally exclude year-end closing entries
                const filteredEntries = entries.filter(entry => {
                    const date = entry.fecha?.toDate ? entry.fecha.toDate() : new Date(entry.createdAt);
                    const isWithinDates = date >= startDate && date <= endDate;
                    if (!isWithinDates) return false;
                    if (excludeClosing && entry.tipoReferencia === 'CIERRE') return false;
                    return true;
                });

                setLedgerEntries(filteredEntries);

                // 3. Calculate Balances
                const newBalances = {}; // accountId -> number

                // Initialize 0
                Object.keys(accountMap).forEach(id => newBalances[id] = 0);

                filteredEntries.forEach(entry => {
                    if (entry.detalles) {
                        entry.detalles.forEach(detail => {
                            const debit = parseFloat(detail.debe || 0);
                            const credit = parseFloat(detail.haber || 0);
                            const netChange = debit - credit;

                            if (newBalances[detail.cuentaId] !== undefined) {
                                newBalances[detail.cuentaId] += netChange;
                            }
                        });
                    }
                });

                setBalances(newBalances);

            } catch (error) {
                console.error("Error fetching accounting data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [condominoId, startDate, endDate, excludeClosing]);

    return { loading, accounts, balances, ledgerEntries };
};
